import { render, staticRenderFns } from "./ProductComponentPriceType.vue?vue&type=template&id=7715039a&"
import script from "./ProductComponentPriceType.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentPriceType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports